import { CountPicker, type CountPickerComponentProps } from "@tenant/ui";

export const RoomCountPicker = (props: CountPickerComponentProps) => (
  <CountPicker {...props} />
);
